module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"title":"编辑数据"},"en":{"title":"Edit Data"},"de":{"title":"Daten bearbeiten"},"es":{"title":"Editar datos"},"fr":{"title":"Modifier les données"},"id":{"title":"Edit Data"},"it":{"title":"Modifica dati"},"jp":{"title":"データを編集"},"kr":{"title":"데이터 편집"},"pt":{"title":"Editar dados"},"tw":{"title":"編輯資料"}}')
  delete Component.options._Ctor
}
